/**
 * Standard methods for Hermes and HTTP requests.
 *
 * @enum {string}
 */
export var Method;
(function (Method) {
    Method["DELETE"] = "DELETE";
    Method["GET"] = "GET";
    Method["OPTIONS"] = "OPTIONS";
    Method["PATCH"] = "PATCH";
    Method["POST"] = "POST";
    Method["PUT"] = "PUT";
    Method["TRACE"] = "TRACE";
})(Method || (Method = {}));
//# sourceMappingURL=method.js.map